module.exports = __webpack_public_path__ + "img/AiNurse.b2432169.png";